import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

const UpdateBanner = () => {
  const { t } = useTranslation();
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const onSwUpdate = (e) => setRegistration(e.detail || null);
    window.addEventListener("sw-update", onSwUpdate);
    return () => window.removeEventListener("sw-update", onSwUpdate);
  }, []);

  const refresh = useCallback(() => {
    const waiting = registration?.waiting;
    if (!waiting) return;

    let done = false;
    const reloadNow = () => {
      if (!done) {
        done = true;
        navigator.serviceWorker.removeEventListener(
          "controllerchange",
          onChange,
        );
        window.location.reload();
      }
    };

    const onChange = () => reloadNow();

    // Primary: reload when the new SW takes control
    navigator.serviceWorker.addEventListener("controllerchange", onChange);

    // Fallback: if it activates very fast or controllerchange is flaky
    waiting.addEventListener("statechange", function onState() {
      if (waiting.state === "activated") {
        waiting.removeEventListener("statechange", onState);
        reloadNow();
      }
    });

    // Ask the waiting SW to activate
    waiting.postMessage({ type: "SKIP_WAITING" });
  }, [registration]); // ← important: depend on registration

  if (!registration?.waiting) return null;

  return (
    <div
      className="alert alert-primary d-flex align-items-center justify-content-between fixed-bottom m-0 rounded-0"
      role="status"
      aria-live="polite"
      style={{ zIndex: 1050 }}
    >
      <span>
        {t("update.newVersionAvailable", "A new version is available.")}
      </span>
      <button
        type="button"
        className="btn btn-light fw-semibold"
        onClick={refresh}
      >
        {t("update.refreshNow", "Refresh now")}
      </button>
    </div>
  );
};

export default UpdateBanner;
